import React from "react";
import styled, { useTheme } from "styled-components";
import sortImg from "../../asserts/img/sortUp.svg";
import ReactSelect from "react-select";
import { components } from "react-select";

const SelectContainer = styled.div`
  flex: 1;
  margin-left: 1em;
  margin-right: 1em;
`;

const StyledSelect = styled(ReactSelect)(({ props }) => ({
  fontSize: props.style?.fontSize || 16,
}));

const SelectStatus = ({
  value,
  name,
  options,
  onChange,
  width,
  height,
  backgroundColor,
  placeholder,
  ...props
}) => {
  const theme = useTheme();
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <img src={sortImg} alt="input-sown-img" />
      </components.DropdownIndicator>
    );
  };

  const Control = ({ children, ...props }) => {
    return <components.Control {...props}>{children}</components.Control>;
  };

  return (
    <SelectContainer style={{ ...props.style }}>
      <StyledSelect
        props={{ ...props }}
        styles={{
          container: (base) => ({
            ...base,
            backgroundColor: backgroundColor,
            borderRadius: 18,
            width: width ? width : "100%",
            border: `1px solid #57689F`,
          }),
          control: (base) => ({
            ...base,
            backgroundColor: backgroundColor,
            boxShadow: 0,
            border: 0,
            borderRadius: 18,
            height: 34,
            width: "100%",
          }),

          singleValue: (base) => ({
            ...base,
            width: width ? width : "100%",
          }),
          input: (base) => ({
            ...base,
            textAlign: "right",
            color: theme.color.text,
            fontSize: props.style?.fontSize || 16,
          }),
          indicatorSeparator: () => {},
          indicatorsContainerCSS: {
            alignSelf: "flex-start",
          },
          menuList: (base) => ({
            ...base,
            marginRight: 5,
          }),
          placeholder: (base) => ({
            ...base,
            textAlign: "right",
            color: theme.color.text,
            fontSize: props.style?.fontSize || 16,
          }),
        }}
        closeMenuOnSelect={true}
        components={{ DropdownIndicator, Control }}
        options={options}
        mame={name}
        value={value}
        defaultValue={value}
        onChange={onChange}
        notEmpty={value !== "none"}
        placeholder={
          value && value !== "none" ? value : placeholder
        }></StyledSelect>
    </SelectContainer>
  );
};

export default SelectStatus;
